import * as React from 'react';
import {useState} from 'react';
import Box from '@mui/material/Box';
import Messages from "./Messages";
import {postAPI} from "../api";

import {LocalFireDepartment, Send} from "@mui/icons-material";
import Container from "@mui/material/Container";
import {CircularProgress} from "@mui/material";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import {InputLabel} from "@mui/material";

interface chatProps {
    notif: (m: string) => void;
}

export interface Story {
    role: string;
    content: string;
    time: string
}

export default function Chat({notif}: chatProps) {

    const [command, setCommand] = useState("");
    const st: string | null = localStorage.getItem("story")
    let sto: Story[] = [];
    if (st) {
        sto = JSON.parse(st) as Story[]
    }

    const [story, setStory] = useState<Story[]>(sto);
    const [processing, setProcessing] = useState(false);


    const addMessage = () => {
        const text = command.trim();
        if (!text)
            return;

        const url = localStorage.getItem("site-url");
        if (!url) {
            const urlField = document.getElementById("site-scan-field")!;
            urlField.style.backgroundColor = "rgba(256, 0, 0, 0.5)";
            setTimeout(() => {
                urlField.style.backgroundColor = "";
            }, 2000);
            notif("first enter the website address!");
            return;
        }

        setCommand("");

        const updatedStory: Story[] = [...story, {
            role: "user",
            content: text,
            time: new Date().toLocaleTimeString()
        }];
        setStory(updatedStory);
        setProcessing(true);

        postAPI("/ai", {req: text, url: url, story: updatedStory}).then(([ok, status, msg]) => {
            if (ok) {
                const assistantMessage: Story = {
                    role: "assistant",
                    content: msg.answer,
                    time: new Date().toLocaleTimeString()
                };
                setStory(st => [...st, assistantMessage]);
            } else {
                notif("Не удалось выполнить запрос. " + status);
            }
            setProcessing(false);
        })
    }

    const keyPress = (e: any) => {
        if (processing) return;
        if (e.keyCode === 13) {
            e.preventDefault();
            addMessage()
        }
    }

    const textChange = (value: string) => {
        setCommand(value)
    }

    const clearHistory = () => {
        const res = window.confirm("Are you sure you want to delete all history? It cannot be restored");
        if (res) {
            localStorage.removeItem("story");
            setStory([]);
        }
    }

    return (
        <Container>
            <div style={{maxWidth: "80vw"}}>
                <Messages story={story}/>
            </div>
            <Box color="primary" maxWidth="80vw" sx={{display: "flex", alignItems: "center"}}>
                <IconButton disabled={processing} onClick={clearHistory} title="clear history" sx={{
                    color: "auto",
                    ":hover": {color: "orange"},
                    transition: "color 0.4s"
                }}><LocalFireDepartment/></IconButton>

                <FormControl sx={{m: 1, width: "80vw"}} onKeyDown={(e) => keyPress(e)}>
                    <InputLabel sx={{userSelect: "none"}}>type message</InputLabel>
                    <OutlinedInput
                        onChange={(e) => textChange(e.target.value)}
                        value={command}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={addMessage}
                                    edge="end"
                                    disabled={processing}
                                >
                                    {processing ? <CircularProgress/> : <Send/>}

                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </Box>
        </Container>
    );
}
